module.exports = __webpack_public_path__ + "img/image5.fd071d67.png";